module.exports = __webpack_public_path__ + "img/hair.1e8e9769.svg";